export default {
  API_URI: "/api"
};
